'use client';

import { useEffect } from 'react';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface BlogPostViewTrackerProps {
  postSlug: string;
  postTitle: string;
}

export function BlogPostViewTracker({ postSlug, postTitle }: BlogPostViewTrackerProps) {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.blog.postViewed({ postSlug, postTitle });
  }, [postSlug, postTitle, analytics]);

  return null;
}
